import { ReactNode } from 'react';

export function StandardStepSubtitleText({
  children
}: Readonly<{ children: ReactNode }>) {
  return <p className="text-3 mb-4 sm:text-4">{children}</p>;
}
